import homeProgressNavbar from 'url:../../../assets/images/home-progress-navbar.webp';
import statusbar from 'url:../../../assets/images/home-progress-0.webp';
import homeProgress1 from 'url:../../../assets/images/my-progress-1.webp';
import homeProgress2 from 'url:../../../assets/images/my-progress-2.webp';
import homeProgress3 from 'url:../../../assets/images/my-progress-3.webp';
import homeProgress4 from 'url:../../../assets/images/my-progress-4.webp';
import homeProgress5 from 'url:../../../assets/images/my-progress-5.webp';
import homeProgress6 from 'url:../../../assets/images/my-progress-6.webp';
import homeProgress7 from 'url:../../../assets/images/my-progress-7.webp';
import homeProgress8 from 'url:../../../assets/images/my-progress-8.webp';
import homeProgress9 from 'url:../../../assets/images/my-progress-9.webp';
import homeProgress10 from 'url:../../../assets/images/my-progress-10.webp';

export const myProgressAssets = {
  homeProgressNavbar,
  statusbar,
  homeProgress1,
  homeProgress2,
  homeProgress3,
  homeProgress4,
  homeProgress5,
  homeProgress6,
  homeProgress7,
  homeProgress8,
  homeProgress9,
  homeProgress10,
} as const;

export const myProgressAssetList = Object.values(myProgressAssets);
